<products-banner></products-banner>
<div class="ez-section-card">
    <div class="ez-products">
        <ekvegit></ekvegit>
        <sales></sales>
    </div>
</div>